<template>
    <div class="reports-table">
        <div class="reports-table__actions">
            <div class="reports-table__filter">
                <!-- eslint-disable vue/no-deprecated-v-bind-sync -->
                <v-autocomplete
                    v-model="filters.client.value"
                    :search-input.sync="search"
                    :loading="clientsIsFetching"
                    :items="filtersItems.clients"
                    dense
                    :label="$t('pages.report.client')"
                    hide-details
                    hide-no-data
                    placeholder="Client"
                ></v-autocomplete>
            </div>
            <div class="reports-table__filter">
                <v-autocomplete
                    v-model="filters.user.value"
                    :items="filtersItems.users"
                    dense
                    :label="$t('pages.report.employee')"
                    hide-details
                    placeholder="Employee"
                ></v-autocomplete>
            </div>
            <div class="reports-table__filter">
                <v-autocomplete
                    v-model="filters.status.value"
                    :items="filtersItems.status"
                    dense
                    chips
                    multiple
                    clearable
                    hide-details
                    :placeholder="textContent['status']"
                    class="compact-chip-autocomplete"
                >
                    <template #selection="{ item, index }">
                        <v-chip
                            v-if="index === 0"
                            small
                            class="mr-1"
                            close
                            @click:close="removeChip(item)"
                        >
                            {{ item.text }}
                        </v-chip>

                        <span
                            v-if="
                                index === 1 && filters.status.value.length > 1
                            "
                            class="status-chip-more"
                        >
                            +{{ filters.status.value.length - 1 }}
                        </span>
                    </template>
                </v-autocomplete>
            </div>
        </div>
        <div class="reports-table__table">
            <v-data-table
                :headers="headers"
                :items="filteredEmployees"
                :items-per-page="-1"
                :footer-props="{
                    'items-per-page-text': $t('pages.report.rowsPerPage'),
                }"
                :no-data-text="$t('pages.report.noDataAvailable')"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                class="elevation-1"
                dense
                multi-sort
                hide-default-footer
                @click:row="clickHandle"
                @update:sort-by="updateSortBy"
                @update:sort-desc="updateSortDesc"
            >
                <!--    eslint-disable-next-line -->
                <template #item.is_repair_wig="{ item }">
                    <template v-if="item.is_repair_wig">
                        <v-icon small color="red">mdi-wrench</v-icon>
                    </template>
                </template>

                <!--    eslint-disable-next-line -->
                <template #item.activity_title="{ item }">
                    <div class="reports-table__action">
                        <p class="reports-table__action-title">
                            {{ $t(`pages.report.${item.activity_title}`) }}
                        </p>
                        <p class="reports-table__action-desc">
                            {{
                                getActivityDescriptionByTranslateHandle(
                                    item.activity_description
                                )
                            }}
                        </p>
                    </div>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.created_at="{ item }">
                    <span style="direction: ltr; display: inline-block">
                        <DateCell :value="item.created_at" />
                    </span>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.totally="{ item }">
                    <div
                        v-if="
                            (item.totally || item.totally === 0) &&
                            item.total_cost
                        "
                        class="reports-table__status"
                    >
                        <div class="reports-table__status-circle">
                            <v-progress-circular
                                :rotate="270"
                                :size="45"
                                :width="6"
                                :value="(item.totally / item.total_cost) * 100"
                                :color="
                                    getColor(
                                        (item.totally / item.total_cost) * 100
                                    )
                                "
                            >
                            </v-progress-circular>
                            <div class="value">
                                {{
                                    Math.ceil(
                                        (item.totally / item.total_cost) * 100
                                    )
                                }}%
                            </div>
                        </div>
                        <div
                            v-if="item.total_cost - item.totally !== 0"
                            class="reports-table__status-debt"
                        >
                            <p>debt</p>
                            {{ item.total_cost - item.totally }}
                        </div>
                        <div v-else class="reports-table__status-check">
                            <v-icon color="#3cc516">
                                mdi-check-decagram-outline
                            </v-icon>
                        </div>
                    </div>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import languageMixin from '@/mixins/language.mixin'
import languageOrderExtraMixin from '@/mixins/language-order-extra.mixin'
import { mapActions, mapGetters } from 'vuex'
import { getterTypes } from '@/store/modules/report'
import { getterTypes as getterTypesUsers } from '@/store/modules/users'
import { getFullDayFirstFull } from '@/helpers/getDateInFormat'
import { actionTypes as actionTypesOrders } from '@/store/modules/orders'
import DateCell from '@/components/common/cells/date-cell.vue'
import wigTransitions from '@/helpers/transitions/wig-transitions'
import {
    clientsV2ActionTypes,
    clientsV2GetterTypes,
} from '@/store/modules/clients_v2/types'
import prepareSortOptionsReports from '@/helpers/prepare-sort-options-reports.utils'
import arraysEqual from '@/helpers/arrays-equal.helper'
import regularToSnakeCase from '@/helpers/regular-to-snake-case'
import languagePropertiesMixin from '@/mixins/language-properties.mixin'

export default {
    name: 'ReportsUsersTable',
    components: { DateCell },
    mixins: [languageMixin, languageOrderExtraMixin, languagePropertiesMixin],
    emits: ['sort-change', 'filters-change'],
    data() {
        return {
            key: '',
            search: '',
            preparedSortParams: '',
            sortBy: [],
            sortDesc: [],
            sortKeys: {
                created_at: 'created_at',
            },
            itemsForStepFilter: [
                { text: 'Wig Building', value: 'WIG_BUILDING' },
                { text: 'Sawing Weft', value: 'SAWING_WEFT' },
                {
                    text: 'Neck adjustment',
                    value: 'SAWING_WEFT_NECK_ADJUSTMENT',
                },
                { text: 'Inner Ear Shortening', value: 'INNER_EAR_SHORTENING' },
                {
                    text: 'Depth in the net',
                    value: 'SAWING_WEFT_DEPTH_IN_THE_NET',
                },
                {
                    text: 'Band adjustment',
                    value: 'SAWING_WEFT_ELASTIC_BAND_ADJUSTMENT',
                },
                { text: 'Pin adjustment', value: 'SAWING_WEFT_PIN_ADJUSTMENT' },
                { text: 'Ear adjustment', value: 'SAWING_WEFT_EAR_ADJUSTMENT' },

                { text: 'Skins Connect', value: 'SKINS_CONNECT' },
                { text: 'Sawing Weft On Cap', value: 'SAWING_WEFT_ON_CAP' },
                { text: 'Front Hand Tie', value: 'FRONT_HAND_TIE' },
                {
                    text: 'Classic Hairline - Home Work',
                    value: 'CLASSIC_HAIRLINE_HOME_WORK',
                },
                { text: 'First Hairline', value: 'FIRST_HAIRLINE' },
                {
                    text: 'First Hairline Tracing - Home Work',
                    value: 'FIRST_HAIRLINE_HOME_WORK',
                },
                { text: 'Second Hairline', value: 'SECOND_HAIRLINE' },
                {
                    text: 'Under Lace Material Sawing',
                    value: 'UNDER_LACE_MATERIAL_SAWING',
                },
                {
                    text: 'Under lace material closing',
                    value: 'UNDER_LACE_MATERIAL_CLOSING',
                },
                {
                    text: 'Highlights Include Washing',
                    value: 'HIGHLIGHTS_INCLUDE_WASHING',
                },
                {
                    text: 'Special Shampoo',
                    value: 'SPECIAL_SHAMPOO',
                },
                { text: 'Washing', value: 'WASHING' },
                { text: 'Cut And Set', value: 'CUT_AND_SET' },
            ],
            filters: {
                client: {
                    items: [
                        {
                            text: this.$t('pages.report.any'),
                            value: '',
                        },
                        {
                            text: 'Client 001',
                            value: 'client-001',
                        },
                        {
                            text: 'Client 002',
                            value: 'client-002',
                        },
                    ],
                    value: '',
                },
                user: {
                    items: [
                        {
                            text: this.$t('pages.report.any'),
                            value: '',
                        },
                    ],
                    value: '',
                },
                status: {
                    items: [],
                    value: [],
                },
            },
        }
    },
    computed: {
        ...mapGetters('clientsV2', {
            getAllClients: clientsV2GetterTypes.GET_ITEMS,
            clientsIsFetching: clientsV2GetterTypes.GET_LOADING,
        }),
        ...mapGetters('report', {
            getAllEmployees: getterTypes.getAllEmployees,
        }),
        ...mapGetters('users', {
            getAllUsers: getterTypesUsers.getAllUsers,
        }),
        textPayment: function () {
            return (
                this.getTextForSelected(this.lang, 'OrderModalDepositUpdate') ||
                ''
            )
        },
        items: function () {
            return []
        },
        headers: function () {
            return [
                //TODO: add translate
                {
                    text: this.$t('pages.report.kind'),
                    value: 'is_repair_wig',
                    align: 'center',
                    width: '1%',
                    sortable: false,
                },
                { text: this.textContent['created'], value: 'created_at' },
                {
                    text: this.textContent['barcode'],
                    value: 'barcode',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.employee'),
                    value: 'employees_name',
                    sortable: false,
                },
                {
                    text: this.textContent['client'],
                    value: 'client',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.action'),
                    value: 'activity_title',
                    sortable: false,
                    width: 300,
                },
                {
                    text: this.$t('pages.report.status'),
                    value: 'totally',
                    sortable: false,
                    width: 175,
                },
            ]
        },
        filteredEmployees: function () {
            return this.getAllEmployees.employees ?? []
        },
        filtersItems: function () {
            const clients = this.getAllClients.map(({ full_name, id }) => ({
                text: full_name,
                value: id,
            }))
            const users = this.getAllUsers.map(({ nickName, id }) => ({
                text: nickName,
                value: id,
            }))

            const status = this.itemsForStepFilter.map((i) => ({
                ...i,
                text: this.textTitle(i.text),
            }))

            return {
                clients: [
                    { text: this.$t('pages.report.any'), value: '' },
                    ...clients,
                ],
                users: [
                    { text: this.$t('pages.report.any'), value: '' },
                    ...users,
                ],
                status,
            }
        },
    },
    watch: {
        search: function (val) {
            const selected = this.filtersItems.clients.find(
                (c) => c.value === this.filters.client.value
            )

            const runSearch = () => {
                clearTimeout(this.searchQueryTimeout)
                this.searchQueryTimeout = setTimeout(() => {
                    this.setSearchQuery(val)
                }, 500)
            }

            if (val === '') {
                this.fetchClients()
                return
            }

            if (selected && selected.text !== val) {
                runSearch()
                return
            }

            if (!selected && val && val !== 'Any') {
                runSearch()
            }
        },
        filters: {
            handler() {
                this.$emit('filters-change', {
                    client: this.filters.client.value
                        ? [this.filters.client.value]
                        : [],
                    employee: this.filters.user.value
                        ? [this.filters.user.value]
                        : [],
                    status: this.filters.status.value.length
                        ? this.filters.status.value
                        : [],
                })
            },
            deep: true,
        },
        preparedSortParams: function () {
            this.emitSortChange()
        },
    },
    mounted() {
        this.setSearchQuery('')
    },
    methods: {
        ...mapActions('clientsV2', {
            fetchClients: clientsV2ActionTypes.FETCH_ITEMS,
            setSearchQuery: clientsV2ActionTypes.SET_SEARCH_QUERY,
        }),
        ...mapActions('orders', {
            getOrder: actionTypesOrders.loadOrder,
        }),
        dateFormat: function (date) {
            return getFullDayFirstFull(date)
        },
        clickHandle: function (e) {
            if (e.wig_id) {
                wigTransitions.moveToWigPageInNewTab(e.wig_id)
            }
        },
        getColor: function (value) {
            return value >= 100 ? 'green' : value >= 50 ? 'orange' : 'red'
        },
        toCamelCase: function (str) {
            return str
                .toLowerCase()
                .replace(/[_\s]+(.)?/g, (_, chr) =>
                    chr ? chr.toUpperCase() : ''
                )
        },
        containsHebrew: function (str) {
            const regex = /[\u0590-\u05FF]/
            return regex.test(str)
        },
        getActivityDescriptionByTranslateHandle: function (str) {
            if (this.containsHebrew(str)) {
                return str
            }

            const translatedKey = `pages.report.${this.toCamelCase(str)}`
            const translatedText = this.$t(translatedKey)

            if (translatedText.includes('Translation not found for key')) {
                return str
            }

            return translatedText
        },
        updateSortBy: function (value) {
            this.sortBy = value
            const newSortParams = prepareSortOptionsReports(
                this.sortBy,
                this.sortDesc,
                this.sortKeys
            )

            if (arraysEqual(this.preparedSortParams, newSortParams)) {
                return
            }

            this.preparedSortParams = newSortParams
        },
        updateSortDesc: function (value) {
            this.sortDesc = value
            const newSortParams = prepareSortOptionsReports(
                this.sortBy,
                this.sortDesc,
                this.sortKeys
            )

            if (arraysEqual(this.preparedSortParams, newSortParams)) {
                return
            }

            this.preparedSortParams = newSortParams
        },
        emitSortChange: function () {
            this.$emit('sort-change', this.preparedSortParams)
        },
        removeChip: function (item) {
            this.filters.status.value = this.filters.status.value.filter(
                (i) => i !== item.value
            )
        },
        textTitle: function (text) {
            return (
                this.extraContent[regularToSnakeCase(text)] ||
                this.propertiesContent[regularToSnakeCase(text)]
            )
        },
    },
}
</script>

<style lang="scss" scoped>
.reports-table {
    &__totally-row {
        font-weight: 700;
        font-size: 1.1em;
    }
    &__totally {
        width: 100%;
        text-align: right;
    }

    &__actions {
        display: flex;
        margin-bottom: 16px;
        flex-direction: column;
        gap: 16px;

        @include tablet-up {
            justify-content: flex-start;
            flex-direction: row;
        }
    }

    &__filter {
        max-width: 200px;

        &:last-child {
            max-width: 324px;
            min-width: 324px;
        }
    }

    &__action {
        border: 2px solid rgb(150, 122, 220);
        border-radius: 16px;
        padding: 4px 10px;
        width: 100%;
        margin: 3px 0;
    }

    &__action-title {
        font-size: 0.95em;
    }

    &__action-desc {
        padding-left: 5px;
        font-size: 0.8em;
    }
    &__status {
        display: flex;
        gap: 0 10px;
        justify-content: space-between;
        align-items: center;
    }

    &__status-circle {
        min-width: 35px;
        position: relative;

        .value {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            line-height: 0.8;
            font-size: 0.75em;
            font-weight: 700;
            margin-top: 1px;
        }
    }

    &__status-debt {
        text-align: right;
        min-width: 50%;
        border-bottom: 1px solid rgba(0, 0, 0, 0.35);
        p {
            font-size: 0.9em;
            color: rgba(101, 101, 101, 0.85);
        }
    }

    &__status-check {
        margin-left: 15px;
    }
}

.compact-chip-autocomplete {

    ::v-deep .v-select__slot {
        height: 26px !important;
        min-height: 26px !important;
        max-height: 26px !important;
    }

    ::v-deep .v-input__control {
        height: 26px !important;
        min-height: 26px !important;
        max-height: 26px !important;
    }

    ::v-deep .v-input__slot {
        height: 26px !important;
        min-height: 26px !important;
        max-height: 26px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        display: flex;
        align-items: center;
    }

    ::v-deep .v-select__selections {
        display: flex;
        align-items: center;
        overflow: hidden;
        height: 26px !important;

        input {
            max-height: 26px !important;
        }
    }

    ::v-deep .v-chip {
        height: 24px !important;
        min-height: 24px !important;
        font-size: 12px;
        margin-bottom: 2px !important;
    }

    .status-chip-more {
        font-size: 13px;
        opacity: 0.7;
        margin: 0 4px 2px 0;
        line-height: 1;
        display: flex;
        align-items: center;
        height: 24px;
    }
}

::v-deep .v-data-table-header th {
    white-space: nowrap !important;
}

::v-deep .v-data-table-header th .v-data-table-header__content {
    display: flex !important;
    align-items: center;
    gap: 6px;
}
</style>
